import { formatDate, getPrice } from '../../../utils/formatters';

const TrustItemRow = ({ id, data }) => {
  const {
    ItemUsage,
    salesItemId,
    Agreement,
    salesDate,
    itemCategory,
    productDescription,
    salesPrice,
    salesCost,
    due,
    paid,
    itemCode,
    unitTax,
    isECF,
    agreementAdjustmentId,
    assignmentAndTransfer,
  } = data;
  const salesDateValue = salesDate.split('T');
  return (
    <tr key={id} className="table-body-row">
      <td>{ItemUsage?.resourceType}</td>
      <td>{!salesItemId && agreementAdjustmentId ? agreementAdjustmentId : salesItemId}</td>
      <td>{Agreement?.contractNumber}</td>
      <td>{formatDate(salesDateValue[0])}</td>
      <td>{itemCategory || '--'}</td>
      <td>{itemCode ? itemCode?.trim() : '--'}</td>
      <td className={!assignmentAndTransfer && 'assignment-transfer-column'}>
        {assignmentAndTransfer || '-'}
      </td>
      <td>{`${productDescription}${isECF ? ' (ECF)' : ''}`}</td>
      <td>{getPrice(salesPrice)}</td>
      <td>{getPrice(unitTax)}</td>
      <td>{getPrice(salesCost)}</td>
      <td>{getPrice(due)}</td>
      <td>{getPrice(paid)}</td>
    </tr>
  );
};

export default TrustItemRow;
